export default "__VITE_ASSET__sRpBX0rc__"